<template>
    <div class="dm-register-author-button-container">
        <a
            href="#"
            class="btn dm-btn-padding dm-btn-brand font-weight-boldest"
            data-cy="dm-landing-submit-manuscript-button"
            @click.prevent="showRegisterLandingAuthorModal()"
            >{{ translate("Submit your project") }}</a
        >
        <modal id="dm-modal-register-landing-author">
            <RegisterOrLogIn />
        </modal>
    </div>
</template>

<script>
import RegisterOrLogIn from "./forms/RegisterOrLogIn.vue";

export default {
    components: { RegisterOrLogIn },

    methods: {
        showRegisterLandingAuthorModal() {
            jQuery("#dm-modal-register-landing-author").modal();
        },
    },
};
</script>
